import { useEffect, useState } from "react";

interface LoadingTextProps {
  text: string;
}

export function LoadingText({ text }: LoadingTextProps) {
  const [dots, setDots] = useState(1);

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => (prev === 3 ? 1 : prev + 1));
    }, 500);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="fixed inset-0 flex items-center justify-center">
      <div className="font-mono text-xl font-semibold tracking-wider">
        {text}
        <span className="relative">
          <span className="invisible">...</span>
          <span className="absolute left-0">
            {".".repeat(dots)}
          </span>
        </span>
      </div>
    </div>
  );
}
